/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as MediaGetVideo from "./getVideo.defs.js";

const $nsid = "place.stream.media.getVideoList";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"repo":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":100}), 25)),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"videos":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<MediaGetVideo.VideoView>((() => MediaGetVideo.videoView) as any), ),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** List videos newest first. Scoped to a single repo when `repo` is supplied; otherwise lists videos across every indexed repo. Returns hydrated video views with author info and view counts. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["RepoNotFound"]);

export { main };

export const $lxm = $nsid;
